import styles from "./oneDayCard.module.less";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import {CheckInOutPair} from "@src/httpClient/__generated__/Api.ts";
import {useMemo} from "react";
import {Employee} from "@src/httpClient/__generated__/Api.ts";
import {Body_16_Coral_Primary_Regular_16,} from "@UI/typography/generated/typography.tsx";
import {GtDatetime} from "@src/i18n/Gt.tsx";
import {WorkdayState, WorkStatus} from "@src/CommonComponents/WorkStatus/WorkStatus.tsx";
import {
    HistoryPopupElement
} from "@src/Pages/Views/Manager/EventsHistoryElement/HistoryPopupElement/HistoryPopupElement.tsx";
import cn from "classnames";
import {formatDate} from "@src/utils/formatDate.ts";


interface PopupProps {
    date: string
    eventsGroups?: CheckInOutPair[]
    workday?: WorkdayState | null
    // ManyDaysCards: the workdays its days are matched against by date
    workdays?: (WorkdayState & {date: string})[]
    employee?: Employee,
    footerBgColor?: string
    overflowEvents?: boolean
    sortingRule?: "ASC" | "DESC";
}

export const OneDayCard = ({date, eventsGroups, workday, overflowEvents}: PopupProps) => {
    return (
        <Stack direction={"column"}
               gap={24}
               className={styles.whiteBoard}
               style={{maxHeight: overflowEvents ? "100%" : "400px"}}>
            <Stack className={styles.employeeInfo} direction={"column"}>
                <Stack justifyContent={"space-between"} style={{width: "100%"}}>
                    <Stack direction={"column"}>
                        <Body_16_Coral_Primary_Regular_16>
                            <GtDatetime>{date}</GtDatetime>
                        </Body_16_Coral_Primary_Regular_16>
                    </Stack>
                    <WorkStatus workday={workday}/>
                </Stack>
            </Stack>
            <Stack direction={"column"} gap={8}
                   className={cn(styles.eventsGroup, {[styles.overflow]: !overflowEvents})}>
                {(eventsGroups && eventsGroups?.length > 0) ? eventsGroups?.map(e =>
                        <div className={styles.eventElement} key={`${e.event_in?.id ?? e.event_out?.id}-${e.date}`}>
                            <HistoryPopupElement events={e}/>
                        </div>
                    ) :
                    <div className={styles.eventElement}>
                        <HistoryPopupElement/>
                    </div>
                }
            </Stack>
        </Stack>

    )
}


export const ManyDaysCards = ({eventsGroups, workdays, overflowEvents, sortingRule}: PopupProps) => {
    const days = useMemo(() => {
        if (!eventsGroups) return [];

        const _days = new Map<string, CheckInOutPair[]>();
        for (const event of eventsGroups) {
            const event_date = formatDate(event.date)
            if (!_days.has(event_date)) _days.set(event_date, []);
            const cn = _days.get(event_date)!;
            cn.push(event);
            _days.set(event_date, cn);
        }

        return Array.from(_days)
    }, [eventsGroups, overflowEvents, sortingRule]);

    const sorted = useMemo(() => {
        const factor = sortingRule === 'ASC' ? 1 : -1;
        return days.sort(([dateA], [dateB]) => (new Date(dateA).getTime() - new Date(dateB).getTime()) * factor)
    }, [days, sortingRule]);

    if (!sorted.length) return null

    return (
        sorted.map(([date, events]) =>
            <OneDayCard eventsGroups={events} date={date} overflowEvents={overflowEvents} key={date}
                        workday={workdays?.find(w => w.date === date)}/>
        )
    )
}